import getField from '@form/formGenerator'

export const citySaveUrl = `${import.meta.env.VITE_API_URL}/api/cities`

export const cityFormObject = {
  id: null,
  name: null,
  isActive: false
}

export const cityFormFields = (cityFormObject, updateFormObject, saveForm, errors, isLoading, t) => {
  const fields = [
    {
      type: 'text',
      name: 'name',
      label: t('labels.city_name'),
      value: cityFormObject.name,
      key: 'cityFormObject-name',
      cssClass: 'column is-12'
    },
    {
      type: 'switcher',
      name: 'isActive',
      label: t('labels.is_active'),
      value: cityFormObject.isActive,
      cssClass: 'column is-12',
      key: 'cityFormObject-isActive',
      id: 'cityFormObject-isActive'
    },
    {
      type: 'button',
      buttons: true,
      callback: saveForm,
      cancel: false,
      validateText: t('actions.save'),
      cssClassParent: 'column is-12',
      cssClassValidate: 'button is-blue',
      validateIcon: 'icon-done',
      key: 'cityFormObject-form',
      isLoading
    },
    {
      type: 'hidden',
      name: 'id',
      value: parseInt(cityFormObject.id),
      key: 'cityFormObject-id'
    }
  ]
  return fields.map(function (field) {
    return getField({ ...field, error: errors[field.name] ? errors[field.name].errors : '' }, updateFormObject)
  })
}